import {
  InfoCard,
  Link,
  CardWithBadge,
  Button,
  FormField,
  FormGrid,
  FormRow,
} from "@endya-conformite/ui-kit";
import styles from "./CardRenouvellement.module.scss";

export function CardRenouvellement({ millesime }: { millesime: number }) {
  return (
    <CardWithBadge
      label="Rappel"
      hasBadge
      badgeVariant="info"
      className={styles.card}
    >
      <FormGrid>
        <FormRow>
          <FormField>
            <div className={styles.grid}>
              <div className={styles.gridLeft}>
                <h3 className={styles.title}>
                  Votre adhésion touche à sa fin.
                </h3>
                <p className={styles.text}>
                  Elle prendra fin le 31 décembre {millesime}. Le renouvellement
                  d&apos;adhésion doit être effectué pour votre immatriculation
                  à l&apos;Orias.
                </p>
              </div>
              <div className={styles.gridRight}>
                <Link to="/renouvellement/">
                  <Button variant="outline-accent">
                    Renouveler mon adhésion
                  </Button>
                </Link>
              </div>
            </div>
          </FormField>
        </FormRow>
        {millesime === 2023 && (
          <FormRow>
            <FormField>
              <InfoCard type="warning" className={styles.infoCard2023}>
                Si vous souhaitez renouveler votre adhésion pour 2024, il
                n&apos;est pas nécessaire de compléter les axes de conformité
                pour l&apos;année 2023.
              </InfoCard>
            </FormField>
          </FormRow>
        )}
      </FormGrid>
    </CardWithBadge>
  );
}
